module.exports = __webpack_public_path__ + "img/cuentobg.1be90336.png";